import React, { useContext, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ThemeContext } from "../../container/mppmodal/MppInfo";

const PriceInput = ({ setOffersDisplay }) => {
  const {
    totalAmount,
    min,
    max,
    debounceCallback,
    analyticsForAmountEntry,
    isAmountEntryReadonly,
    isFocused,
    isMerchantApiFailed,
    ProductDetails,
    pencilimg,
    offers,
    isSetPayIn4Alone
  } = useContext(ThemeContext);

  const [merchantPrice, setMerchantPrice] = useState(totalAmount);
  const [amountEntryError, setAmountEntryError] = useState("");
  const [borderColor, setBorderColor] = useState("#656565");

  const [borderWidth, setBorderWidth] = useState("1px");

  const minAmt = isSetPayIn4Alone ? parseFloat(offers[0].minPurchase): parseFloat(min);
  const maxAmt = isSetPayIn4Alone ? parseFloat(offers[0].maxPurchase): parseFloat(max);

  useEffect(() => {
    const price = merchantPrice && parseFloat(merchantPrice);
    const decimalPart = merchantPrice.split(".")[1];

    const inputPrice =
      decimalPart?.length === 0 ? merchantPrice.split(".")[0] : merchantPrice;

    if (totalAmount !== merchantPrice) {
      setBorderWidth("2px");
        if (price > 0 && price < minAmt) {
          setAmountEntryError(`Please enter an amount to finance above $${min}`);
          setOffersDisplay(false);
          setMerchantPrice(merchantPrice.replace(/^(-)?0+(?=\d)/, "$1"));
          debounceCallback.cancel();
          if(isSetPayIn4Alone) {
            setAmountEntryError(`Please enter an amount between $${minAmt} and $${maxAmt}`);
            debounceCallback(price === 0 ? "0" : inputPrice);
          }
        } else if (price > maxAmt) {
          setAmountEntryError(`Please enter an amount to finance below $${max}`);
          setOffersDisplay(false);
          setMerchantPrice(merchantPrice.replace(/^0+/, ""));
          debounceCallback.cancel();
          if(isSetPayIn4Alone) {
            setAmountEntryError(`Please enter an amount between $${minAmt} and $${maxAmt}`);
            debounceCallback(price === 0 ? "0" : inputPrice);
          }
        } else if (
          (price <= maxAmt && price >= minAmt) ||
          price === 0 ||
          merchantPrice === ""
        ) {
          setAmountEntryError("");
          setBorderColor("#656565");
          debounceCallback(price === 0 ? "0" : inputPrice);
        }
    }
    else if (isMerchantApiFailed) {
      setAmountEntryError("Your order total does not meet the requirements to use this payment method");
      setOffersDisplay(false);
      setMerchantPrice(merchantPrice.replace(/^0+/, ""));
      debounceCallback.cancel();
    }
     else {
      setOffersDisplay(true);
      setAmountEntryError("");
      debounceCallback.cancel();
    }
  }, [merchantPrice]);

  useEffect(() => {
    if (amountEntryError !== "") {
      analyticsForAmountEntry(merchantPrice, amountEntryError);
      setBorderColor("indianred");
    }
  }, [amountEntryError]);

  useEffect(() => {
    const modalBody = document.querySelector(
      ".modal-body, .email-modal-body, .email-product-modal-body"
    );

    if (modalBody) {
      modalBody.style.overflowY = !merchantPrice || Number(merchantPrice) === 0 ? "hidden" : "scroll";
    }
  }, [merchantPrice]);

  const onMerchantPriceChange = ({ target: { value: amount } }) => {
    const regExp = /^\d*(\.\d{0,2})?$/;
    const isValidAmount = regExp.test(amount);
    if (isValidAmount) {
      setMerchantPrice(amount);
    }
  };

  const changeborderAmountentry = () => {
    document.getElementsByClassName(
      "amountEntryInput"
    )[0].style.border = `2px solid ${borderColor}`;

    document.getElementsByClassName(
      "amountEntryInput-text"
    )[0].style.textAlign = "right";
  };
  const changeborderAmountentry2 = () => {
    document.getElementsByClassName(
      "amountEntryInput"
    )[0].style.border = `1px solid ${borderColor}`;

    document.getElementsByClassName(
      "amountEntryInput-text"
    )[0].style.textAlign = "center";
  };

  return (
    <>
      <div
        className="amountEntryInput"
        style={{ border: `${borderWidth} solid ${borderColor}` }}
      >
        <label className="amountEntryInput-dollar">$</label>
        <input
          type="text"
          autocomplete="transaction-amount"
          value={merchantPrice}
          autoFocus={isFocused}
          onFocus={changeborderAmountentry}
          onBlur={changeborderAmountentry2}
          onChange={(evt) => onMerchantPriceChange(evt)}
          readOnly={isAmountEntryReadonly}
          className="amountEntryInput-text"
        ></input>
        <img src={pencilimg} className="pencil-icon" alt="" />
      </div>
      {amountEntryError && (
        <p
          className="amountEntryInputError"
          style={{ color: "indianred" }}
        >
          {amountEntryError}
        </p>
      )}
    </>
  );
};

export default PriceInput;
